import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isPreview: false
};

export const previewSlice = createSlice({
    name: 'preview',
    initialState: initialState,
    reducers: {
        setIsPreview(state, action) {
            state.isPreview = action.payload;
        }
    },
});

export const getIsPreview = state => state.preview.isPreview;


export const {
    setIsPreview
} = previewSlice.actions;

export default previewSlice.reducer;

